import * as React from 'react';
import * as classNames from 'classnames';
import trim = require('lodash/trim');
import {ITestMeta, ITest} from '../../redux/modules/console/reducer';

export interface ITestItemProps {
  test: ITest;
  title: string;
  meta: ITestMeta;
  opened: boolean;
  testError: string;
  onClick: () => void;
}

export class TestItem extends React.Component<ITestItemProps, any> {
  public render(): React.ReactElement<any> {
    const {title, meta, test, testError, onClick, opened} = this.props;
    const defaultTest = {passed: false, actual: 'N/A', stdOut: null, stdError: null};
    const currentTest = test ? test : defaultTest;
    const stdErr = trim(currentTest.stdError || testError);
    const testLogStdOut = test && currentTest.stdOut ? 'test-log' : 'hide';
    const testLogStdErr = test && stdErr ? 'test-log' : 'hide';
    const testColor = !test
      ? 'yellow'
      : currentTest.passed ? 'green' : 'red';
    return (
      <div>
        <div className={classNames('test-offset-1 test-dropdown')} onClick={onClick}>
          <i className={classNames('fa', {
            'fa-caret-down': opened,
            'fa-caret-right': !opened,
            'fa-caret-down-red': test && !currentTest.passed,
            'fa-caret-down-green': test && currentTest.passed,
            'fa-caret-down-yellow': !test,
          })}/>
          <i className={classNames(
            `fa test-offset-1 ${testColor}`,
            {
              'fa-exclamation-circle': !currentTest.passed,
              'fa-check-circle': currentTest.passed,
            },
          )}/>

          <div className={'test-name'}>{title}</div>
          {!!test
            ? <div className={classNames('test-summary', {'hide': opened})}>
                <span>Input:&nbsp;{meta.input}</span>,
                <span>Expected:&nbsp;{meta.output}</span>,
                <span>Actual:&nbsp;{currentTest.actual}</span>
              </div>
            : <div className={'test-summary'}>Inconclusive: the test did not run because a previous test had failed</div>
          }
        </div>

        <div className={classNames('test-details test-offset-3', {'active': opened})}>
          <div><span>Input:</span>&nbsp;<span>{meta.input}</span></div>
          <div><span>Expected:</span>&nbsp;<span>{meta.output}</span></div>
          <div><span>Actual:</span>&nbsp;<span>{currentTest.actual}</span></div>
          <div className={testLogStdOut}>
            <span className='test-details__title'>StdOut:</span>
            <span>{currentTest.stdOut && <pre>{currentTest.stdOut}</pre>}</span>
          </div>
          <div className={testLogStdErr}>
            <span>StdError:</span>
            <span>
              <pre>
                {stdErr}
              </pre>
            </span>
          </div>
        </div>
      </div>
    );
  }
}
